import { ApiService } from './api.service';
import { GradeClass, GradeSchoolClass, SchoolClass } from '@/models/school-class/school-class';
import { SchoolGroup } from '@/models/school-group/school-group';
import { Empty } from '@/models/core/empty';
import { ImportStudentResults } from '@/models/student/import-students-result';
import { BulkUpdateSchoolClassesRequest } from '@/models/school-class/school-class-bulk-update';

class SchoolClassService extends ApiService {
  constructor() {
    super();
  }

  getSchoolClasses(headers: any): Promise<SchoolClass[]> {
    return this.getList(SchoolClass, `/schoolClasses`, {}, headers);
  }

  getGradeClass(headers: any): Promise<GradeClass[]> {
    return this.getList(GradeClass, `/grades`, {}, headers);
  }

  getGradeSchoolClasses(headers: any): Promise<GradeSchoolClass[]> {
    return this.getList(GradeSchoolClass, `/grades/schoolClasses`, {}, headers);
  }

  getSchoolGroups(studentID: number = 1): Promise<SchoolGroup[]> {
    return this.getList(SchoolGroup, `students/${studentID}/schoolGroups`, {});
  }

  downloadSchoolClassRegistrationTemplate(): Promise<Blob> {
    return this.downloadFile('schoolClasses/template', {});
  }

  uploadSchoolClassExcelFile(params: FormData): Promise<ImportStudentResults> {
    return this.postFile(ImportStudentResults, 'schoolClasses/import', params);
  }

  bulkUpdateSchoolClasses(bulkUpdateSchoolClassesRequest: BulkUpdateSchoolClassesRequest): Promise<Empty> {
    return this.put(Empty, 'schoolClasses/bulkUpdate', bulkUpdateSchoolClassesRequest);
  }
}

export const schoolClassService = new SchoolClassService();
